import { Icon, Input } from 'antd';
import { AfspLayout } from '@bit/ui-common.ui-components/afsp';
import logo from '@bit/ui-common.ui-components/afsp/images/dhs-logo-01.png';
import user from '@bit/ui-common.ui-components/afsp/images/user-icon-01.png';
import { YourAccount } from '@bit/ui-common.ui-components/ss-common-data';

const 
{ TextArea } = Input,
layout = {
    size: { header: 'xs', footer: 'xs' },
    images: { logo, user },
    controlType: 'user',
    bgc: '#e6e6e6',
    menu: { account: {
        component: () => <YourAccount />
    }}
};

export default class extends React.Component {
    state = { copied: false, resetTimer: false }
    constructor(props) { super(props); }

    copyOnClick = () => {
        const { resetTimer } = this.state;
        let copyText = document.getElementById('ftttf-sid-token');

        copyText.select();
        document.execCommand('copy');
        
        if (!resetTimer) setTimeout(this.shouldResetClickToCopy, 3000);
        this.setState({...this.state, 
            copied: true,
            resetTimer: !resetTimer ? true : resetTimer
        });
    }

    shouldResetClickToCopy = () => {
        const { copied } = this.state;
        if (copied) this.setState({...this.state, 
            copied: false,
            resetTimer: false
        });
    }

    render() {
        const { copied } = this.state;
        return (
            <AfspLayout {...layout}>
                <div className='ftttf-sid-container'>
                    <div 
                        onClick={this.copyOnClick} 
                        className='ftttf-click-to-copy-container'
                    >
                        <Icon type='copy' style={{ fontSize: '1.5em', marginRight: '8px' }} />
                        <span className='ftttf-click-to-copy-text'>
                            {copied ? 'Copied!' : 'Click to copy'}
                        </span>
                    </div>
                    <div 
                        onClick={this.copyOnClick}
                        className='ftttf-sid-id-text'
                    >
                        <span>
                            <TextArea 
                                id='ftttf-sid-token'
                                rows={13}
                                value={`sid=${window.session.token || null}`}
                            />
                        </span>
                    </div>
                </div>
            </AfspLayout>
        );
    }
}
